module.exports = __webpack_public_path__ + "static/media/e97df92a17fb8aeb0773cd423f0c6ff2.8af5cf63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/posters/e97df92a17fb8aeb0773cd423f0c6ff2.jpg
// module id = 273
// module chunks = 0